import { observer } from "mobx-react-lite";
import React from "react";
import {
  getScreenConnectionLabel,
  IScreenStatus,
} from "../../app/models/screens";


interface IParams {
  screen: IScreenStatus;
}

export const ScreenLabelFormatter: React.FC<IParams> = ({ screen }) => {
  return <>{getScreenConnectionLabel(screen)}</>;
};

export default observer(ScreenLabelFormatter);
